import React, { useEffect, useState, useRef } from 'react';
import { FiFileText, FiUser, FiBarChart2, FiMessageSquare, FiFile, FiUpload } from 'react-icons/fi';
import TemplatesConfigure from "../../configuration/TemplatesConfigure.jsx"
import SummaryConfigure from "../../configuration/SummaryConfigure.jsx"
import ConcernInsightConfigure from "../../configuration/ConcernInsightConfigure.jsx"
import { IoIosPersonAdd } from "react-icons/io";
import { FaTimes } from 'react-icons/fa';
import BusinessInsightConfigure from '../../configuration/BusinessInsightConfigure.jsx';
import AgentFeedbackConfigure from "../../configuration/AgentFeedbackConfigure.jsx"
import ConversationDispositionConfigure from "../../configuration/ConversationDispositionConfigure.jsx"
import LeadQualityConfigure from "../../configuration/LeadQualityConfigure.jsx"
import CustomModuleConfigure from "../../configuration/CustomModuleConfigure.jsx"
import { Settings, PencilLine, X, Wand2 } from 'lucide-react';
import server from '../../../api/server.js';
import "../../../dashboard-components/loader.css"
import { useToast } from '../../../context/ToastContext.jsx';
import UnauthorizedPage from "../../layouts/UnauthorizedPage.jsx";
import ModernDatePicker from '../../layouts/ModernDatePicker.jsx';
import { IoAlertCircleOutline } from 'react-icons/io5';
import { LuDownload } from 'react-icons/lu';
import Papa from 'papaparse';

const AppsManagement = ({serviceID, clientID}) => {
  const { showToast } = useToast();
  const [activeTab, setActiveTab] = useState('All Apps');
  const [showTemplatesModal, setShowTemplatesModal] = useState(false)
  const [showSummaryModal, setShowSummaryModal] = useState(false)
  const [showConcernInsightsModal, setShowConcernInsightModal] = useState(false)
  const [showBusinessInsightModal, setShowBusinessInsightModal] = useState(false)
  const [showAgentFeedbackModal, setShowAgentFeedbackModal] = useState(false)
  const [showCustomModuleModal, setShowCustomModuleModal] = useState(false)
  const [showConversationDispositionModal, setShowConversationDispositionModal] = useState(false)
  const [showLeadQualityModal, setShowLeadQualityModal] = useState(false)
  const [pendingCloseModal, setPendingCloseModal] = useState(null); // "Templates", "Summary", etc.
  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const [totalCost, setTotalCost] = useState(0)
  const [currentBalance, setCurrentBalance] = useState(0)
  const [balanceValid, setBalanceValid] = useState(0)
  const [selectedType, setSelectedType] = useState('date')
  const [conversationIDs, setConversationIDs] = useState([])
  const [customerIDs, setCustomerIDs] = useState([])
  const [statement, setStatement] = useState(null)
  const [fileData, setFileData] = useState(null)
  const [csvFileName, setCsvFileName] = useState(null)
  const [csvFile, setCsvFile] = useState(null)
  const requiredColumnsConversation = ['ID']
  const requiredColumnsCustomer = ['CUSTOMER ID']
  const [role] = useState(()=> {
    const userCookie = getCookie('dashboard_login_user_creds');
    if (userCookie) {
      const userData = JSON.parse(userCookie);
      const role = userData.role
      return role
    }
    return 'admin';
  })


  const [showModal, setShowModal] = useState(false);
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedStatuses, setSelectedStatuses] = useState(null);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedRecordTypes, setSelectedRecordTypes] = useState([]);
  const [affectedCount, setAffectedCount] = useState(0); // This would come from the backend API
  const [client_id, setClient_id] = useState(null)
  const [service_id, setService_id] = useState(null)
  const [email, setEmail] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isApplying, setIsApplying] = useState(false)
  const [canApply, setCanApply] = useState(false)
  const [configData, setConfigData] = useState(null)
  const [selectedRecordType, setSelectedRecordType] = useState(null)
  const handleConfigData = (data) => {
    setConfigData(data)
  }
  const handleUpdateConfig = async (module_name) => {
    try {
      let res = await server.postModuleDraftSaveConfiguration({client_id, service_id, email, module_name, 'configuration': configData, 'menu': 'apps', 'submenu': undefined})
      if(res.status === 200) {
        showToast('Draft saved successfully', "success")
      }
    } catch (error) {
    }
  }

  // Sample status options
  const statusOptions = [
    { value: 'completed', label: 'Completed' },
    { value: 'error', label: 'Error' }
  ];

  // Record type options
  const recordTypeOptions = [
    { value: 'call', label: 'Call' },
    { value: 'chat', label: 'Chat' }
  ];

  // Sample module options
  const [moduleOptions, setModuleOptions] = useState([
    { value: 'conversation_summary', available: true, label: 'Conversation Summary', enabled: false },
    { value: 'agent_feedback', available: true, label: 'Agent Feedback', enabled: false },
    { value: 'business_insights', available: true, label: 'Business Insights', enabled: false },
    { value: 'concerns_and_queries', available: true, label: 'Concerns & Queries', enabled: false },
    { value: 'templates', available: true, label: 'Templates', enabled: false },
    { value: 'conversation_dispositions', available: true, label: 'Conversation Dispositions', enabled: false },
    ,{ value: 'lead_quality', available: true, label: 'Lead Quality', enabled: false },
    { value: 'custom_module', available: true, label: 'Custom Module', enabled: false }
  ]);

  const toggleStatus = (value) => {
    if (value === 'error') {
      setSelectedModules(
        moduleOptions
          .filter(app => app.available && app.enabled)
          .map(option => option.value)
      );
    }
    setSelectedStatuses(value)
  };

  const toggleModule = (value) => {
    if (selectedModules.includes(value)) {
      setSelectedModules(selectedModules.filter(module => module !== value));
    } else {
      setSelectedModules([...selectedModules, value]);
    }
  };
  
  const toggleRecordType = (value) => {
    if (selectedRecordTypes.includes(value)) {
      setSelectedRecordTypes(selectedRecordTypes.filter(type => type !== value));
    } else {
      setSelectedRecordTypes([...selectedRecordTypes, value]);
    }
  };

  const handleDownloadSampleID = () => {
    const sampleFilePath = "/assets/sample_id_records.csv";
  
    fetch(sampleFilePath)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sample_id.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => console.error("Error downloading sample CSV:", error));
  };
  const handleDownloadSampleCustomer = () => {
    const sampleFilePath = "/assets/sample_customer_records.csv"; // Adjust the path if needed
  
    fetch(sampleFilePath)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sample_customer.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => console.error("Error downloading sample CSV:", error));
  };

  const fileRef = useRef(null);

  const parseCsvAsyncConversation = (file) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        transformHeader: (header) => header.trim().toLowerCase(),
        skipEmptyLines: true,
        complete: (result) => {
          const headers = result.meta.fields.map((item) => item.trim().toLowerCase());
          const isValid = requiredColumnsConversation.every((col) => headers.includes(col.toLowerCase()));
          if (!isValid) {
            return reject(new Error("Invalid CSV format. Please use the provided sample."));
          }
          resolve(result.data);
        },
        error: (err) => reject(err),
      });
    });
  };
  const parseCsvAsyncCustomer = (file) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        transformHeader: (header) => header.trim().toLowerCase(),
        skipEmptyLines: true,
        complete: (result) => {
          const headers = result.meta.fields.map((item) => item.trim().toLowerCase());
          const isValid = requiredColumnsCustomer.every((col) => headers.includes(col.toLowerCase()));
          if (!isValid) {
            return reject(new Error("Invalid CSV format. Please use the provided sample."));
          }
          resolve(result.data);
        },
        error: (err) => reject(err),
      });
    });
  };

  const handleFileUploadConversation = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    fileRef.current = file; // store synchronously
    setFileData(file)

    // Pre-parse the CSV so user gets faster feedback, but we still guard in handleBulkRecord.
    parseCsvAsyncConversation(file)
      .then((data) => {
        if(data.length > 2000 && data.length > 0) {
          setCsvFile(null)
          setCsvFileName(null)
          setFileData(null)
          setStatement('error');
          showToast('CSV file can have a maximum of 2000 rows', "error")
          return;
        }
        setCsvFileName(file.name);
        if (selectedType === 'id') {
          setConversationIDs(data.map(row => row['id']).filter(Boolean));
          setCustomerIDs([])
        }
        setCsvFile(data);
        setStatement('success');
      })
      .catch((err) => {
        console.error(err);
        setStatement('error');
      })
      .finally(() => {
        setTimeout(() => setStatement(null), 4000);
      });
  };
  const handleFileUploadCustomer = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    fileRef.current = file; // store synchronously
    setFileData(file)

    // Pre-parse the CSV so user gets faster feedback, but we still guard in handleBulkRecord.
    parseCsvAsyncCustomer(file)
      .then((data) => {
        if(data.length > 2000 && data.length > 0) {
          setCsvFile(null)
          setCsvFileName(null)
          setFileData(null)
          setStatement('error');
          showToast('CSV file can have a maximum of 2000 rows', "error")
          return;
        }
        setCsvFileName(file.name);
        if (selectedType === 'customer') {
          setCustomerIDs(data.map(row => row['customer id']).filter(Boolean));
          setConversationIDs([])
        }
        setCsvFile(data);
        setStatement('success');
      })
      .catch((err) => {
        console.error(err);
        setStatement('error');
      })
      .finally(() => {
        setTimeout(() => setStatement(null), 4000);
      });
  };
  
  // App data with toggle states
  const [apps, setApps] = useState([
    {
      id: 1,
      display_name: 'Conversation Summary',
      name: "conversation_summary",
      icon: <FiFileText size={24} />,
      description: 'Generate detailed summaries of your customer interactions',
      enabled: false,
      available: true
    },
    {
      id: 2,
      display_name: 'Agent Feedback',
      name: 'agent_feedback',
      icon: <FiUser size={24} />,
      description: 'Monitor and evaluate agent performance metrics',
      enabled: false,
      available: true
    },
    {
      id: 3,
      display_name: 'Business Insights',
      name: 'business_insights',
      icon: <FiBarChart2 size={24} />,
      description: 'Extract key business metrics and trends from conversations',
      enabled: false,
      available: true
    },
    {
      id: 4,
      display_name: 'Concerns & Queries',
      name: 'concerns_and_queries',
      icon: <FiMessageSquare size={24} />,
      description: 'Track and manage customer concerns and questions',
      enabled: false,
      available: true
    },
    {
      id: 5,
      display_name: 'Templates',
      name: 'templates',
      icon: <FiFile size={24} />,
      description: 'Manage and customize response templates',
      enabled: false,
      available: true
    },
    {
      id: 6,
      display_name: 'Conversation Dispositions',
      name: 'conversation_dispositions',
      icon: <PencilLine size={24} />,
      description: 'Configure dispositions for categorizing conversation outcomes',
      enabled: false,
      available: true
    },
    {
      id: 7,
      display_name: 'Lead Quality',
      name: 'lead_quality',
      icon: <IoIosPersonAdd size={24} />,
      description: 'Monitor and evaluate lead quality metrics',
      enabled: false,
      available: true
    },
    {
      id: 8,
      display_name: 'Custom Module',
      name: 'custom_module',
      icon: <Wand2 size={24} />,
      description: 'Configure custom modules for your business',
      enabled: false,
      available: true
    }
  ]);

  // Toggle app enabled state
  const toggleApp = (id) => {
    // setApps(apps.map(app => 
    //   app.id === id ? { ...app, enabled: false } : app
    // ));
    switch (id) {
      case 1:
        setShowSummaryModal(true);
        break;
      case 2:
        setShowAgentFeedbackModal(true);
        break;
      case 3:
        setShowBusinessInsightModal(true);
        break;
      case 4:
        setShowConcernInsightModal(true);
        break;
      case 5:
        setShowTemplatesModal(true);
        break;
      case 6:
        setShowConversationDispositionModal(true);
        break;
      case 7:
        setShowLeadQualityModal(true);
        break;
      case 8:
        setShowCustomModuleModal(true);
        break;
      default:
        break;
    }
  };

  const ToggleSwitch = ({ isOn, onToggle }) => {
    return (
      <div 
      className={`relative inline-block w-12 h-5 rounded-full cursor-pointer transition-colors duration-200 ease-in-out ${isOn ? 'bg-indigo-600' : 'bg-gray-200'}`}
        onClick={onToggle}
      >
        <div 
          className={`absolute top-0 left-0 bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isOn ? 'translate-x-7' : ''}`}
        />
      </div>
    );
  };
  function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }
  const getDefaultModules = async () => {
    try {
      setIsLoading(true)
        let res = await server.defaultModuleStatus(client_id, service_id, email, 'apps', undefined);
        if (res.status === 200) {
            let resp = await res.json();
            if (resp.data) {
              setApps(prevApps =>
                prevApps.map(app => {
                  const matchedModule = resp.data.find(module => module.module_name === app.name);
                  return {
                    ...app,
                    enabled: matchedModule?.status || false,
                    available: !!matchedModule
                  };
                })
              );
              setModuleOptions(prevOptions =>
                prevOptions.map(option => {
                  const matchedModule = resp.data.find(module => module.module_name === option.value);
                  return {
                    ...option,
                    available: !!matchedModule,
                    enabled: matchedModule?.status || false,
                  };
                })
              );
            }            
            setIsLoading(false)
        }
    } catch (error) {
      setIsLoading(false)
    }
};
  useEffect(() => {
      const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
      if (user) {
        setEmail(user.email);
      }
      if (serviceID) {
        setService_id(serviceID);
      }
      if(clientID){
        setClient_id(clientID)
      }
    }, [serviceID, clientID]);
  
    useEffect(() => {
      if (client_id && service_id && email && role !== 'employee') {
        getDefaultModules();
      }
    }, [client_id, service_id, email]);

    const handleApply = async () => {
      try {
        setIsLoading(true)
        setIsApplying(true)
        let config = {
          date_range: {
            start: dateRange.start,
            end: dateRange.end
          },
          processing_status: selectedStatuses,
          modules_list: selectedModules,
          record_type: selectedRecordTypes,
        }
        if (selectedType === 'id') {
          config.conversation_ids = conversationIDs;
        } else if (selectedType === 'customer') {
          config.customer_ids = customerIDs;
        }
        
        let res = await server.applyConversationChanges({
          client_id,
          service_id: Array.isArray(service_id) ? service_id[0] : service_id,
          email,
          menu: 'apps',
          submenu: undefined,
          configuration: config
        })
        if(res.status === 200) {
          showToast('Modules are being processed. You will be notified once the changes are applied.', "success")
          setShowModal(false)
          setSelectedStatuses([])
          setSelectedModules([])
          setSelectedRecordTypes([])
          setDateRange({ start: '', end: '' })
          setConversationIDs([])
          setCustomerIDs([])
          setFileData(null)
          setCsvFileName(null)
          setCsvFile(null)
        }
      } catch (error) {
      } finally {
        setIsLoading(false)
        setIsApplying(false)
      }
    }

  const handleApplyCount = async () => {
    try {
      setIsApplying(true)
      let config = {
        date_range: {
          start: dateRange.start,
          end: dateRange.end
        },
        processing_status: selectedStatuses,
        modules_list: selectedModules,
        record_type: selectedRecordTypes,
      }
      if (selectedType === 'id') {
        config.conversation_ids = conversationIDs;
      } else if (selectedType === 'customer') {
        config.customer_ids = customerIDs;
      }
      
      let resp = await server.checkConversationChanges(
        client_id,
        Array.isArray(service_id) ? service_id[0] : service_id,
        email,
        'apps',
        undefined,
        config
      )

      if(resp.status === 200) {
        let data = await resp.json()
        setTotalCost(data.total_cost)
        setCurrentBalance(data.current_balance)
        setBalanceValid(data.valid || 0)
        if((data.total_cost <= data.current_balance) || data.valid === 1) {
          setCanApply(true)
        }
        else{
          setCanApply(false)
        }
        setAffectedCount(data.total_count)
      }
    } catch (error) {
      showToast('Failed to apply changes', "error")
    } finally {
      setIsApplying(false)
    }
  }

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowModal(false)
        setConfigData(null);
      }
    }
    if (showModal) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    }
  }, [showModal])

  useEffect(() => {
    if (
      (dateRange.start && dateRange.end && selectedStatuses && selectedModules.length > 0 && selectedRecordTypes.length > 0)
      || (conversationIDs.length > 0 && selectedRecordTypes.length > 0)
      || (customerIDs.length > 0 && selectedRecordTypes.length > 0)
    ) {
      handleApplyCount()
    } else {
      setCanApply(false)
    }
  }, [dateRange, selectedStatuses, selectedModules, selectedRecordTypes, conversationIDs, customerIDs])

  // App Card component
  const AppCard = ({ icon, title, description, isEnabled, onToggle }) => {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 cursor-pointer" onClick={onToggle}>
        <div className="flex justify-between items-start">
          {/* Left: Icon */}
          <div className="flex items-start flex-1">
            <div className="mr-4 mt-1">
              {icon}
            </div>
            
            {/* Middle: Title and Description */}
            <div className="flex-1 min-w-0">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
              <p className="text-gray-500 text-sm line-clamp-2">{description}</p>
            </div>
          </div>
          
          {/* Right: Configure and Toggle */}
          <div className="flex items-center space-x-4 ml-4 flex-shrink-0">
            <button 
              className="flex items-center text-gray-500"
            >
              <Settings size={20} className="text-gray-500" />
              <span className="ml-2 text-gray-500 text-sm">Configure</span>
            </button>
            <ToggleSwitch isOn={isEnabled} />
          </div>
        </div>
      </div>
    );
  };
  const FilterTab = ({ label, active, onClick }) => {
    return (
      <button
        className={`px-4 py-2 rounded-full text-sm font-medium ${
          active ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-600 hover:bg-gray-100'
        }`}
        onClick={onClick}
      >
        {label}
      </button>
    );
  };

  return (
    <div className={`${role!=='employee' && 'py-3 px-5'} bg-gray-50`} style={{height: "100%", overflowY: "auto"}}>
      {role !== 'employee' && <div className="w-full mx-auto">
        {/* Header Section */}
        <div className="mb-8">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Apps</h1>
          <p className="text-gray-500 text-sm">Configure and manage your AI-powered apps</p>
        </div>

      {/* Filter Tabs and Add New App in the same line */}
      <div className="flex justify-between items-center mb-6">
          <div className="flex space-x-2 bg-gray-100 p-2 rounded-lg inline-flex">
            <FilterTab 
              label="All Apps" 
              active={activeTab === 'All Apps'} 
              onClick={() => setActiveTab('All Apps')}
            />
          </div>
          
          <button 
          className="flex items-center px-4 py-2 rounded text-white font-medium"
          style={{ backgroundColor: 'rgb(79, 70, 229)' }}
          onClick={() => setShowModal(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Run Apps
        </button>
        </div>
      
      {
        activeTab === 'All Apps' && !isLoading && (
          <div className="grid grid-cols-2 gap-6 mb-8">
        {
          apps.filter(app => app.available).map((app) => {
            return (
              <AppCard
              key={app.id}
              icon={app.icon}
              title={app.display_name}
              description={app.description}
              isEnabled={app.enabled}
              onToggle={() => toggleApp(app.id)}
            />
            )
          })
        }
      </div>
        )
      }
      {activeTab === 'Coming Soon' && !isLoading && (
          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <h2 className="text-xl font-medium mb-4">Coming Soon</h2>
            <div className="grid grid-cols-2 gap-6">
              <div className="border border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
                <h3 className="text-lg font-medium text-gray-700 mb-2">Custom Bot Builder</h3>
                <p className="text-gray-600 text-sm">Build custom chatbots with specific knowledge bases and workflows</p>
                <span className="inline-block bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded mt-2">Coming Q2 2025</span>
              </div>
              <div className="border border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
                <h3 className="text-lg font-medium text-gray-700 mb-2">Voice Analytics</h3>
                <p className="text-gray-600 text-sm">Advanced voice analytics with emotion detection and customer sentiment analysis</p>
                <span className="inline-block bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded mt-2">Coming Q3 2025</span>
              </div>
            </div>
          </div>
        )}
        {
        isLoading && (
          <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
            <div className="loader"></div>
            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
          </div>
        )
        }
      </div>}
      {
        role === 'employee' && (
          <UnauthorizedPage/>
        )
      }
      {showConfirmClose && (
        <div style={{zIndex: "9999999999", position: "fixed", top: "0", left: "0", height: "100%", width: "100%", background: "rgba(0,0,0, 0.5)"}}>
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative">
          <div className="flex justify-between items-center p-4 pb-2">
            <h2 className="text-xl text-gray-700" style={{fontWeight: "550"}}>Changes will not be saved</h2>
            <button 
              onClick={() => {
                setPendingCloseModal(null);
                setShowConfirmClose(false);
              }}
              className="text-gray-500 hover:text-gray-700"
            >
             <FaTimes style={{color: "slategray"}}/>
            </button>
          </div>
          
          <div className="p-6 pt-2">
            <p className="text-gray-500 text-sm">You have made changes that haven't been saved.</p>
          </div>
          
          <div className="flex justify-end gap-3 p-6 pt-0">
            <button
              onClick={() => {
                if (pendingCloseModal === "templates") setShowTemplatesModal(false);
                else if (pendingCloseModal === "conversation_summary") setShowSummaryModal(false);
                else if (pendingCloseModal === "concerns_and_queries") setShowConcernInsightModal(false);
                else if (pendingCloseModal === "business_insights") setShowBusinessInsightModal(false);
                else if (pendingCloseModal === "agent_feedback") setShowAgentFeedbackModal(false);
                else if (pendingCloseModal === "conversation_dispositions") setShowConversationDispositionModal(false);
                else if (pendingCloseModal === "lead_quality") setShowLeadQualityModal(false);
                else if (pendingCloseModal === "custom_module") setShowCustomModuleModal(false);
                setConfigData(null)

                setPendingCloseModal(null);
                setShowConfirmClose(false);
              }}
              className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50" style={{height: "40px", borderRadius: "4px"}}
            >
              Discard
            </button>
            <button onClick={() => {
                if (pendingCloseModal === "templates") setShowTemplatesModal(false);
                else if (pendingCloseModal === "conversation_summary") setShowSummaryModal(false);
                else if (pendingCloseModal === "concerns_and_queries") setShowConcernInsightModal(false);
                else if (pendingCloseModal === "business_insights") setShowBusinessInsightModal(false);
                else if (pendingCloseModal === "agent_feedback") setShowAgentFeedbackModal(false);
                else if (pendingCloseModal === "conversation_dispositions") setShowConversationDispositionModal(false);
                else if (pendingCloseModal === "lead_quality") setShowLeadQualityModal(false);
                else if (pendingCloseModal === "custom_module") setShowCustomModuleModal(false);
                setPendingCloseModal(null);
                setShowConfirmClose(false);
                handleUpdateConfig(pendingCloseModal)
              }}
              className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50" style={{height: "40px", borderRadius: "4px"}}
            >
              Save as Draft
            </button>
            <button onClick={() => {
                  setPendingCloseModal(null);
                  setShowConfirmClose(false);
                }}
              className="px-6 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700" style={{height: "40px", borderRadius: "4px"}}
            >
              Stay
            </button>
          </div>
        </div>
      </div>
        </div>
      )}
      {
        showTemplatesModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("templates");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <TemplatesConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="templates" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("templates"); setShowTemplatesModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showSummaryModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("conversation_summary");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <SummaryConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="conversation_summary" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("conversation_summary"); setShowSummaryModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showConcernInsightsModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("concerns_and_queries");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <ConcernInsightConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="concerns_and_queries" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("concerns_and_queries"); setShowConcernInsightModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showBusinessInsightModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("business_insights");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <BusinessInsightConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="business_insights" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("business_insights"); setShowBusinessInsightModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showAgentFeedbackModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("agent_feedback");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <AgentFeedbackConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="agent_feedback" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("agent_feedback"); setShowAgentFeedbackModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showConversationDispositionModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("conversation_dispositions");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <ConversationDispositionConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="conversation_dispositions" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("conversation_dispositions"); setShowConversationDispositionModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showLeadQualityModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("lead_quality");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <LeadQualityConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="lead_quality" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("lead_quality"); setShowLeadQualityModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {
        showCustomModuleModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
            <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
              zIndex: "999999999", padding: "15px"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setPendingCloseModal("custom_module");setShowConfirmClose(true);}}><FaTimes style={{color: "slategray"}}/></div>
            <CustomModuleConfigure config_data={handleConfigData} clientID={client_id} serviceID={service_id} module_name="custom_module" setCloseModal={()=> {setShowConfirmClose(false); setPendingCloseModal("custom_module"); setShowCustomModuleModal(false); getDefaultModules()}}/>
            </div>
          </div>
        )
      }
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{background: "rgba(0,0,0,0.5)"}}>
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md overflow-y-auto" style={{ height: "93vh", maxWidth: "800px" }}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-900">Run Apps</h3>
              <button 
                onClick={() => {setShowModal(false); setSelectedStatuses([]); setSelectedRecordTypes([]); setSelectedModules([]); setTotalCost(0); setCurrentBalance(0); setAffectedCount(0); setDateRange({start: "", end: ""}); setConversationIDs([]); setCustomerIDs([]); setFileData(null); setCsvFileName(null); setCsvFile(null)}}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes style={{color: "slategray"}}/>
              </button>
            </div>
            
            {/* Date Range */}
            <div style={{overflow: "auto", height: "73vh", padding: "10px"}}>
            <div className="mb-4">
              <div className="flex items-center mb-2">
                <div className={`text-gray-700 text-sm cursor-pointer px-3 py-1.5 ${selectedType === 'date' ? ' bg-gray-100 text-gray-800 font-medium rounded' : ''}`} onClick={()=>{setSelectedType('date'); setCsvFile(null); setCsvFileName(null); setConversationIDs([]); setCustomerIDs([]);}}>Select Date Range</div>
                <div className={`text-gray-700 text-sm ml-2 cursor-pointer px-3 py-1.5 ${selectedType === 'id' ? ' bg-gray-100 text-gray-800 font-medium rounded' : ''}`} onClick={()=>{setSelectedType('id'); setCsvFile(null); setCsvFileName(null); setCustomerIDs([]);}}>Upload Conversation IDs</div>
                <div className={`text-gray-700 text-sm ml-2 cursor-pointer px-3 py-1.5 ${selectedType === 'customer' ? ' bg-gray-100 text-gray-800 font-medium rounded' : ''}`} onClick={()=>{
                  setSelectedType('customer');
                  setCsvFile(null);
                  setCsvFileName(null);
                  setConversationIDs([]);
                  // Auto-select status and record types; modules are enabled for selection (do NOT auto-select)
                  setSelectedStatuses('completed');
                  setSelectedRecordTypes(recordTypeOptions.map(opt => opt.value));
                }}>Upload Customer IDs</div>
              </div>
              
              {selectedType === 'date' && <div className="grid grid-cols-2 gap-4 z-11">
                <div>                  
                <ModernDatePicker placeholder="Start Date" value={dateRange.start} onChange={(e)=>setDateRange({...dateRange, start: e.target.value})}/>
                </div>
                <div>
                  <ModernDatePicker placeholder="End Date" value={dateRange.end} onChange={(e)=>setDateRange({...dateRange, end: e.target.value})}/>
                </div>
              </div>}
              {selectedType === 'id' && <div className="p-4 space-y-4">
                
                <div className="flex items-center justify-center">
                  <button onClick={handleDownloadSampleID} className="flex items-center gap-2 px-4 py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px"}}>
                    <LuDownload className="w-4 h-4" />
                    Download sample CSV format
                  </button>
                </div>
                
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
                    <div className="flex text-sm text-gray-600 justify-center" style={{fontSize: "13px"}}>
                      <label className="relative cursor-pointer rounded-md font-medium text-indigo-600">
                        <span>Upload a CSV file</span>
                        <input type="file" accept=".csv" className="global-input sr-only" onChange={handleFileUploadConversation} />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">CSV up to 50MB (max 2000 rows)</p>
                    {csvFile && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-700">{csvFileName}</p>
                        </div>
                      )}
                  </div>
                </div>
                {statement && (<div style={{textAlign: "center", fontSize: "13px", color: (statement === 'success') ? "green":"red"}}>{statement === 'success' ? '':'Invalid CSV format. Please use the provided sample format.'}</div>)}
              </div>}
              {selectedType === 'customer' && <div className="p-4 space-y-4">
                
                <div className="flex items-center justify-center">
                  <button onClick={handleDownloadSampleCustomer} className="flex items-center gap-2 px-4 py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px"}}>
                    <LuDownload className="w-4 h-4" />
                    Download sample CSV format
                  </button>
                </div>
                
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
                    <div className="flex text-sm text-gray-600 justify-center" style={{fontSize: "13px"}}>
                      <label className="relative cursor-pointer rounded-md font-medium text-indigo-600">
                        <span>Upload a CSV file</span>
                        <input type="file" accept=".csv" className="global-input sr-only" onChange={handleFileUploadCustomer} />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">CSV up to 50MB (max 2000 rows)</p>
                    {csvFile && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-700">{csvFileName}</p>
                        </div>
                      )}
                  </div>
                </div>
                {statement && (<div style={{textAlign: "center", fontSize: "13px", color: (statement === 'success') ? "green":"red"}}>{statement === 'success' ? '':'Invalid CSV format. Please use the provided sample format.'}</div>)}
              </div>}
            </div>
            
            {/* Processing Status */}
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 text-sm">Processing Status</label>
              <div className="border rounded-lg">
                <div className="overflow-y-auto">
                  
                  {statusOptions.map((option, idx) => (
                    <label key={option.value} className={`flex items-center p-2 hover:bg-gray-50 ${ idx > 0 ? 'border-t':''} border-gray-200`}>
                      <input
                        type="radio" 
                        className="h-3 w-3 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500 text-sm" class="global-input"
                        style={{ accentColor: 'rgb(79 70 229)' }}
                        checked={selectedStatuses === option.value}
                        onChange={() => toggleStatus(option.value)}
                        disabled={selectedType === 'customer'}
                      />
                      <span className="ml-2 text-gray-700 text-sm">{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            {/* Record Type */}
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700 text-sm">Record Type</label>
              <div className="border rounded-lg">
                <div className="sticky top-0 z-10 bg-gray-100 rounded-t-lg">
                  <label className="flex items-center p-2">
                    <input
                      type="checkbox" 
                      className="h-3 w-3 text-indigo-600 rounded-lg text-sm border" class="global-input"
                      style={{ accentColor: 'rgb(79 70 229)' }}
                      checked={selectedRecordTypes.length === recordTypeOptions.length} 
                      onChange={() => {
                        if (selectedRecordTypes.length === recordTypeOptions.length) {
                          setSelectedRecordTypes([]);
                        } else {
                          setSelectedRecordTypes(recordTypeOptions.map(option => option.value));
                        }
                      }}
                      disabled={selectedType === 'customer'}
                    />
                    <span className="ml-2 text-gray-700 font-medium text-sm">Select All</span>
                  </label>
                </div>
                <div className="overflow-y-auto">
                  {recordTypeOptions.map(option => (
                    <label key={option.value} className="flex items-center p-2 hover:bg-gray-50 border-t border-gray-200">
                      <input
                        type="checkbox" 
                        className="h-3 w-3 text-indigo-600 rounded border-gray-300 focus:ring-indigo-500 text-sm" class="global-input"
                        style={{ accentColor: 'rgb(79 70 229)' }}
                        checked={selectedRecordTypes.includes(option.value)}
                        onChange={() => toggleRecordType(option.value)}
                        disabled={selectedType === 'customer'}
                      />
                      <span className="ml-2 text-gray-700 text-sm">{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Modules */}
            <div className="mb-6">
              <label className="block mb-1 font-medium text-gray-700 text-sm">Select Apps <span style={{fontSize: "12px", fontStyle: "italic"}}>(showing active apps only)</span></label>
              <div className="border rounded-lg">
                <div className="sticky top-0 z-10 bg-gray-100 rounded-t-lg">
                  <label className="flex items-center p-2">
                    <input
                      type="checkbox" 
                      className="h-3 w-3 text-indigo-600 rounded-lg text-sm border" class="global-input"
                      style={{ accentColor: 'rgb(79 70 229)' }}
                      checked={selectedModules.length === moduleOptions.filter(app => app.available && app.enabled).length}
                      onChange={() => {
                        if (selectedModules.length === moduleOptions.filter(app => app.available && app.enabled).length) {
                          setSelectedModules([]);
                        } else {
                          setSelectedModules(moduleOptions.filter(app => app.available && app.enabled).map(option => option.value));
                        }
                      }} disabled={selectedStatuses === 'error'}
                    />
                    <span className="ml-2 text-gray-700 font-medium text-sm">Select All</span>
                  </label>
                </div>
                <div className="overflow-y-auto">
                  
                  {moduleOptions.filter(app => app.available && app.enabled).map(option => (
                    <label key={option.value} className="flex items-center p-2 hover:bg-gray-50 border-t border-gray-200">
                      <input
                        type="checkbox" 
                        className="h-3 w-3 text-indigo-600 rounded-lg text-sm border" class="global-input"
                        style={{ accentColor: 'rgb(79 70 229)' }}
                        checked={selectedModules.includes(option.value)}
                        onChange={() => toggleModule(option.value)}
                        disabled={selectedStatuses === 'error'}
                      />
                      <span className="ml-2 text-gray-700 text-sm">{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="mb-4">
              <p className="text-sm text-blue-600">Note: 
                <li className='ml-4'>Running analysis will replace existing results for the selected modules.</li>
                <li className='ml-4'>Reruns are billed at 50%, error cases that require full processing are billed at full credits.</li>
              </p>
            </div>
            </div>
            
            {/* Apply To and Actions */}
            <div className="flex pt-4 border-t border-gray-200">
              <div className="flex-grow">
                <span className="font-medium text-base flex items-center">Apply to {affectedCount} conversations 
                  {totalCost > 0 && <span className="block md:ml-2 text-sm text-gray-500">[Est. Credits: {Math.ceil(totalCost, 2) || '-'} | Current Balance: {Math.ceil(currentBalance, 2) || '-'}]</span>
                }</span>
              {totalCost > currentBalance && balanceValid === 0 && <span className="text-sm text-red-500 block" style={{marginTop: "0.4rem", fontStyle: "italic"}}>
                Insufficient Credits. Please recharge or reduce selection.
              </span>}
              </div>
              <div className="flex space-x-3">
                <button 
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border border-gray-300 rounded text-gray-700 text-base"
                >
                  Cancel
                </button>
                <button 
                  className="px-4 py-2 rounded text-white font-medium text-base disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ backgroundColor: 'rgb(79 70 229)' }}
                  onClick={handleApply}
                  disabled={!canApply || isApplying}
                >
                  {isApplying ? 'Applying...' : 'Apply'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppsManagement;